const ACCEPTED_DOMAIN = {
    local: ['https://local-teacher.iamservice.net:8443/', 'https://dev-teacher.iamservice.net/'],
    dev: ['https://local-teacher.iamservice.net:8443/', 'https://dev-teacher.iamservice.net/'],
    real: ['https://teacher.iamservice.net/'],
}

export default ACCEPTED_DOMAIN;
